<template lang="pug">
div
  v-form(ref="form")
    //- Campaign details
    v-card.pa-6.mt-4.round-xl(outlined)
      v-row
        v-col(cols="6")
          div.text-md.font-semibold.neutral700--text Campaign name
          .text-sm.neutral700--text(style="margin-top: 2px;") Enter the name of your campaign.
          v-text-field.text-sm.mt-2.round-xl(v-model="offer.name" placeholder="Enter your campaign name" outlined dense height="48" hide-details="auto")
    //- Offer code
    v-card.pa-6.mt-4.round-xl(outlined)
      v-row
        v-col(cols="6")
          div.text-md.font-semibold.neutral700--text Offer code
          .text-sm.neutral700--text(style="margin-top: 2px;") Set on how your customer will redeem this offer
          v-radio-group.mt-0(v-model="offer.redeem_method" @change="sanitizeUnusedObject(['coupon_code'])")
            v-radio.mt-3(value="general_code" color="neutral700" style="align-items: unset;")
              template(v-slot:label)
                div.text-md.font-medium.neutral700--text Create general coupon code
            template(v-if="offer.redeem_method && offer.redeem_method === 'general_code'")
              v-text-field.text-sm.mt-2.round-xl.pl-8(v-model="offer.coupon_code" placeholder="Enter your code here" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
            v-radio.mt-3(value="unique_code" color="neutral700")
              template(v-slot:label)
                div.text-md.font-medium.neutral700--text Generate unique coupon code for every customer
    //- Applies to
    template(v-if="marketingSetting.plan === 'standalone'")
      connect-to-checkout
    template(v-else)
      v-card.pa-6.mt-4.round-xl(outlined)
        div.text-md.font-semibold.neutral700--text Applies to
        v-radio-group.mt-0(v-model="offer.upon_any_purchase" @change="sanitizeUnusedObject(null,['purchase_products'])")
          v-radio.mt-3(:value="true" color="neutral700")
            template(v-slot:label)
              div.text-md.font-medium.neutral700--text All inventory & services
          v-radio.mt-3(:value="false" color="neutral700" style="align-items: unset;")
            template(v-slot:label)
              div.text-md.font-medium.neutral700--text Specific inventory & services
        template(v-if="offer.hasOwnProperty('upon_any_purchase') && !offer.upon_any_purchase")
          inventory-services-selection(v-model="offer.purchase_products")
    //- Offer reward
    v-card.pa-6.mt-4.round-xl(outlined)
      div.text-md.font-semibold.neutral700--text Offers reward
      .text-sm.neutral700--text(style="margin-top: 2px;") Setup your offers reward
      v-radio-group.mt-0(v-model="offer.reward_type" @change="sanitizeUnusedObject(['discount_percentage', 'discount_amount', 'free_item_type', 'free_item_name'], ['free_products'])")
        v-row(no-gutters)
          v-col(cols="6")
            v-radio.mt-3(value="discount_percentage" color="neutral700")
              template(v-slot:label)
                div
                  div.text-md.font-medium.neutral700--text Percentage discount (%)
                  div.text-sm.font-normal.neutral700--text Make a discount based on percentage of the full price
            template(v-if="offer.reward_type && offer.reward_type === 'discount_percentage'")
              v-text-field.text-sm.mt-2.round-xl.pl-8(v-model="offer.discount_percentage" placeholder="0.0" outlined dense height="48" :rules="rules.not_empty" suffix="%" type="number" hide-details="auto")
        v-row(no-gutters)
          v-col(cols="6")
            v-radio.mt-3(value="discount_amount" color="neutral700")
              template(v-slot:label)
                div
                  div.text-md.font-medium.neutral700--text Fixed amount discount (RM)
                  div.text-sm.font-normal.neutral700--text Make a discount based on a fixed amount
            template(v-if="offer.reward_type && offer.reward_type === 'discount_amount'")
              v-text-field.text-sm.mt-2.round-xl.pl-8(v-model="offer.discount_amount" placeholder="0.00" outlined dense height="48" :rules="rules.not_empty" :prefix="$currency.symbol" type="number" hide-details="auto")
        v-row(no-gutters)
          v-col(cols="6")
            v-radio.mt-3(value="free_item" color="neutral700")
              template(v-slot:label)
                div
                  div.text-md.font-medium.neutral700--text Free
                  div.text-sm.font-normal.neutral700--text Give free inventory/services/visit/other item
        v-row(no-gutters)
          v-col(cols="10")
            template(v-if="offer.reward_type && offer.reward_type === 'free_item'")
              div.ml-8
                v-row
                  v-col(cols="6")
                    y-select.mt-2(v-model="offer.free_item_type" placeholder="Select reward" attach :items="[{ text: 'Applied inventory and services', value: 'product' }, { text: 'Visit', value: 'visit' }, { text: 'Other item', value: 'other' }]" item-text="text" item-value="value" :rules="rules.not_empty_select" @change="sanitizeUnusedObject(['free_item_name'], ['free_products'])")
                  v-col(v-if="offer.free_item_type && offer.free_item_type === 'other'")
                    v-text-field.text-sm.mt-2.round-xl(v-model="offer.free_item_name" placeholder="Enter item name" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
        div.ml-8(v-if="offer.reward_type && offer.reward_type === 'free_item' && offer.free_item_type && offer.free_item_type === 'product'")
          inventory-services-selection(v-model="offer.free_products")
    //- Maximum discount uses
    v-card.pa-6.mt-4.round-xl(outlined)
      v-row
        v-col(cols="6")
          div.text-md.font-semibold.neutral700--text Maximum discount uses
          .text-sm.neutral700--text(style="margin-top: 2px;") Set the usage limit of this offer
          v-radio-group.mt-0(v-model="offer.usage_limit_type" @change="sanitizeUnusedObject(['usage_limit'])")
            v-radio.mt-3(value="one_each" color="neutral700" style="align-items: unset;")
              template(v-slot:label)
                div.text-md.font-medium.neutral700--text Limit to one use per customer
            v-radio.mt-3(value="quantity" color="neutral700")
              template(v-slot:label)
                div.text-md.font-medium.neutral700--text Limit number of times this discount can be used
            template(v-if="offer.usage_limit_type && offer.usage_limit_type === 'quantity'")
              v-text-field.text-sm.mt-2.round-xl.pl-8(v-model="offer.usage_limit" placeholder="Enter number of times" outlined dense height="48" :rules="rules.not_empty" type="number" suffix="times" hide-details="auto")
    //- Offer period
    v-card.pa-6.mt-4.round-xl(outlined)
      v-row
        v-col(cols="6")
          div.text-md.font-semibold.neutral700--text Offer period
          .text-sm.neutral700--text(style="margin-top: 2px;") Set active period for this offer
      v-row
        v-col(cols="6")
          v-card.round-xl(outlined color="neutral200" style="border-color: var(--v-neutral300) !important;")
            div.pa-4
              div.text-md.font-semibold.neutral700--text.mb-2 Starts date
              v-radio-group.ma-0(v-model="offer.is_start_immediately" hide-details)
                v-radio.mt-3(:value="true" color="neutral700")
                  template(v-slot:label)
                    div.text-md.font-medium.neutral700--text Immediately after this offer is created
                v-radio.mt-3(:value="false" color="neutral700" style="align-items: unset;")
                  template(v-slot:label)
                    div.text-md.font-medium.neutral700--text Later on:
              v-row.mt-4.ml-7(v-if="!offer.is_start_immediately" dense)
                v-col.grow
                  .text-sm.font-semibold.mb-1 Date
                  date-picker-field(v-model="startDate" required)
                v-col.grow
                  .text-sm.font-semibold.mb-1 Time
                  v-text-field.text-sm.round-xl(v-model="startTime" outlined dense height="48" :rules="rules.not_empty" type="time" hide-details="auto")
        v-col(cols="6")
          v-card.round-xl(outlined color="neutral200" style="border-color: var(--v-neutral300) !important;")
            div.pa-4
              div.text-md.font-semibold.neutral700--text.mb-2 End date
              v-row(dense)
                v-col(cols="2")
                  div.text-md.font-medium.neutral700--text.mt-3 Ends on
                v-col.grow
                  date-picker-field(v-model="endDate" required)
                v-col.grow
                  v-text-field.text-sm.round-xl(v-model="endTime" background-color="neutral100" outlined dense height="48" :rules="rules.not_empty" type="time" hide-details="auto")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { DateTime } from 'luxon'
import InventoryServicesSelection from '@/components/clinic/marketing/InventoryServicesSelection.vue'
import DatePickerField from '@/components/clinic/marketing/DatePickerField.vue'
import ConnectToCheckout from "@/components/clinic/marketing/ConnectToCheckout.vue";

export default {
  components: {
    ConnectToCheckout, InventoryServicesSelection, DatePickerField
  },
  data () {
    return {
      startDate: null,
      startTime: '00:00',
      endDate: null,
      endTime: '00:00',
      offer: {},
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0 || `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required']
      }
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      storedOffer: 'marketing/getOffer',
      marketingSetting: 'marketing/getMarketingSettings'
    }),
  },
  mounted () {
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData () {
      let offer = JSON.parse(JSON.stringify(this.storedOffer))
      this.audienceGroups = offer.groups.length > 0
      this.filterCustomers = offer.customers.length > 0
      if (offer.start_at) {
        this.startDate = DateTime.fromISO(offer.start_at).toFormat('yyyy-MM-dd')
        this.startTime = DateTime.fromISO(offer.start_at).toFormat('HH:mm')
      }
      if (offer.end_at) {
        this.endDate = DateTime.fromISO(offer.end_at).toFormat('yyyy-MM-dd')
        this.endTime = DateTime.fromISO(offer.end_at).toFormat('HH:mm')
      }
      if (offer.discount_amount) {
        offer.discount_amount = Number(offer.discount_amount) / this.$currency.multiplier
      }
      if (!offer.id) {
        offer.is_start_immediately = !offer.id
      }
      if (offer.id && !offer.is_start_immediately) {
        offer.is_start_immediately = false
      }

      this.offer = offer
    },
    sanitizeUnusedObject (strings, arrays) {
      if (strings && strings.length) {
        strings.forEach(f => {
          if (this.offer[f]) this.offer[f] = null
        })
      }
      if (arrays && arrays.length) {
        arrays.forEach(o => {
          if (this.offer[o]) this.offer[o] = []
        })
      }
    },
    saveData (quit) {
      if (!this.$refs.form.validate()) {
        this.showMessage(['error', this.$t('error_message.please_fill_out_all_required')])
        this.$emit('error')
        return
      }
      let payload = JSON.parse(JSON.stringify(this.offer))
      if (!payload.name) {
        payload.name = 'Draft offer'
      }
      if (payload.discount_amount) {
        payload.discount_amount = Math.round(Number(payload.discount_amount) * this.$currency.multiplier)
      }
      if (this.startDate) {
        payload.start_at = `${this.startDate} ${this.startTime}`
      }
      if (payload.is_start_immediately) {
        payload.start_at = DateTime.local().toFormat('yyyy-MM-dd HH:mm')
      }
      payload.end_at = `${this.endDate} ${this.endTime}`
      payload.purchase_products = this.offer.purchase_products.map(m => m.id)
      payload.free_products = this.offer.free_products.map(m => m.id)
      if (this.offer.id) {
        for (const key in payload) {
          if (payload[key] === null) {
            delete payload[key];
          }
        }
        return this.$axios.patch(`/marketing/${this.company.slug}/offers/${this.offer.id}`, payload)
          .then(resp => {
            this.$store.commit('marketing/setOffer', resp.data)
            if (quit) {
              this.$emit('quit', resp.data.id)
            } else {
              this.$emit('updated', resp.data.id)
            }
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_complete_request')
            if (err.response.data) {
              if (err.response.data.detail) {
                message = err.response.data.detail
              } else {
                let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                if (data) { message = data }
              }
            }
            this.showMessage(['error', message])
            this.$emit('error')
          })
      } else {
        return this.$axios.post(`/marketing/${this.company.slug}/offers`, payload)
          .then(resp => {
            this.$store.commit('marketing/setOffer', resp.data)
            this.$set(this.offer, 'id', resp.data.id)
            if (quit) {
              this.$emit('quit', resp.data.id)
            } else {
              this.$emit('updated', resp.data.id)
            }
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_complete_request')
            if (err.response.data) {
              if (err.response.data.detail) {
                message = err.response.data.detail
              } else {
                let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                if (data) { message = data }
              }
            }
            this.showMessage(['error', message])
            this.$emit('error')
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
</style>